import React from "react";
import Particles from "react-tsparticles";
import logo from "./logo.png";

function TopicSelection({ onSelectTopic }) {
  return (
    <div className="topic-page">
  <Particles
    options={{
      particles: {
        number: {
          value: 45,
        },
        size: {
          value: 2,
        },
        move: {
          enable: true,
          speed: 0.8,
        },
        opacity: {
          value: 0.35,
        },
        links: {
          enable: true,
          distance: 150,
          opacity: 0.25,
          width: 1,
        },
      },
    }}
  />

  <div className="topic-content">
    <div className="topic-logo-wrapper">
      <img
        src={logo}
        alt="Financial Recruiters International and Alexander Raymond"
        className="topic-logo"
      />
    </div>

    <div className="topic-heading">
      <h1>Welcome!</h1>
      <p>Please select a topic to continue</p>
    </div>

    <div className="topic-cards">
      <button
        className="topic-card"
        onClick={() => onSelectTopic("Objections")}
      >
        <div className="topic-icon">💬</div>

        <h2>Objections</h2>

        <p>
          Practice common objections and how to handle them.
        </p>

        <span className="topic-arrow">→</span>
      </button>

      <button
        className="topic-card"
        onClick={() => onSelectTopic("Marketing & Recruiting")}
      >
        <div className="topic-icon">🎯</div>

        <h2>Marketing &amp; Recruiting</h2>

        <p>
          Explore marketing strategies and recruiting techniques.
        </p>

        <span className="topic-arrow">→</span>
      </button>
    </div>
  </div>
</div>
  );
}

export default TopicSelection;